import { Face } from './Face'

export interface FacePileProps {
  names: string[]
  /** How many to draw before stopping. The rest are counted, not shown. */
  limit?: number
  size?: number
}

/**
 * Overlapping faces, for the room header.
 *
 * Deliberately a glance and not a list — it answers "is anyone here" in the
 * width of three avatars. The roster answers who.
 */
export function FacePile({ names, limit = 3, size = 22 }: FacePileProps) {
  const shown = names.slice(0, limit)
  return (
    <span style={{ display: 'flex' }} aria-hidden>
      {shown.map((name, position) => (
        <span
          key={name}
          style={{ width: size, height: size, marginLeft: position ? -7 : 0, flex: 'none' }}
        >
          <Face name={name} size={size} />
        </span>
      ))}
    </span>
  )
}
